import React from 'react';

import { Options, Item, Title, Prefix } from './ProjectOptionsStyles';
import { AppModule } from 'types/DataEnvironment';

type Props = {
  options: Array<AppModule>;
  onClick?: () => void;
};

export const ProjectOptions: React.FC<Props> = ({ options, onClick }) => {
  return (
    <Options>
      {options.map((item: AppModule) => (
        <Item href={item.url} key={item.moduleName} onClick={onClick}>
          <Prefix>{item.abbreviation}</Prefix>
          <Title>{item.name}</Title>
        </Item>
      ))}
    </Options>
  );
};

export default ProjectOptions;
